import { call, put, select } from "redux-saga/effects";
import { notify } from "../../../services/notification";
import api, { makeOptions, queryBuilder } from "../../../services/api";
import ActionsBranchInvoiceOrderNotFinished from "../../ducks/branch-invoices/get-order-not-finished";

const getAuthData = (state) => state.auth.data;

export function* fetch(action) {
  try {
    const { params } = action;
    // const query = params ? queryBuilder(params) : "";
    const url = `branch-invoice-order-not-finished/${params}`;
    const authData = yield select(getAuthData);
    const { data } = yield call(api.get, url, makeOptions(authData));

    yield put(
      ActionsBranchInvoiceOrderNotFinished.success(data)
    );
  } catch (err) {
    notify("error", err.response.data.error.message);
    yield put(
      ActionsBranchInvoiceOrderNotFinished.failure(err.response.data.error.message)
    );
  }
}
